module.exports = __webpack_public_path__ + "static/media/icon--info.a06b9e48.svg";